import React from 'react';
import { Lock, Zap, ShieldCheck, Mail } from 'lucide-react';
export function TrustMicrosection() {
  const items = [{
    icon: <Lock size={24} strokeWidth={1.5} data-id="element-340" />,
    title: 'Pago Seguro',
    desc: 'Encriptación 256-bit'
  }, {
    icon: <Zap size={24} strokeWidth={1.5} data-id="element-341" />,
    title: 'Acceso Inmediato',
    desc: 'Descarga al instante'
  }, {
    icon: <ShieldCheck size={24} strokeWidth={1.5} data-id="element-342" />,
    title: 'Garantía 7 Días',
    desc: 'Satisfacción total'
  }, {
    icon: <Mail size={24} strokeWidth={1.5} data-id="element-343" />,
    title: 'Soporte por Email',
    desc: 'Estamos para ayudarte'
  }];
  return <section className="py-10 px-4 bg-white border-b border-soft/20" data-id="element-344">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-345">
        {items.map((item, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-346">
            <div className="text-relief mb-2 bg-relief/10 p-3 rounded-full" data-id="element-347">
              {item.icon}
            </div>
            <h4 className="font-sans font-bold text-primary text-sm mb-1" data-id="element-348">
              {item.title}
            </h4>
            <p className="text-xs text-ink/60 font-sans" data-id="element-349">{item.desc}</p>
          </div>)}
      </div>
    </section>;
}